<script setup lang="ts">
const content = {
  logo: {
    title: 'Onze makelaars zijn aangesloten bij:',
  },
  socials: {
    title: 'Volg ons op:',
    links: [
      { label: 'Facebook', href: 'https://www.facebook.com/juistemakelaar', icon: 'i-simple-icons-facebook' },
      { label: 'Instagram', href: 'https://www.instagram.com/huisassist_', icon: 'i-simple-icons-instagram' },
      { label: 'LinkedIn', href: 'https://www.linkedin.com/company/huisassist', icon: 'i-simple-icons-linkedin' },
    ],
  },
  trustpilot: {
    href: 'https://nl.trustpilot.com/review/juistemakelaar.nl',
    icon: 'i-simple-icons-trustpilot',
  },
}

const cities = {
  label: 'Steden',
  children: [
    { label: 'Den Haag', href: 'https://juistemakelaar.nl/makelaars/zuid-holland/den-haag/' },
    { label: 'Amsterdam', href: 'https://juistemakelaar.nl/makelaars/noord-holland/amsterdam/' },
    { label: 'Rotterdam', href: 'https://juistemakelaar.nl/makelaars/zuid-holland/rotterdam/' },
    { label: 'Utrecht', href: 'https://juistemakelaar.nl/makelaars/utrecht/utrecht/' },
    { label: 'Breda', href: 'https://juistemakelaar.nl/makelaars/noord-brabant/breda/' },
    { label: 'Groningen', href: 'https://juistemakelaar.nl/makelaars/groningen/groningen/' },
    { label: 'Nijmegen', href: 'https://juistemakelaar.nl/makelaars/gelderland/nijmegen/' },
    { label: 'Tilburg', href: 'https://juistemakelaar.nl/makelaars/noord-brabant/tilburg/' },
    { label: 'Zwolle', href: 'https://juistemakelaar.nl/makelaars/overijssel/zwolle/' },
    { label: 'Eindhoven', href: 'https://juistemakelaar.nl/makelaars/noord-brabant/eindhoven/' },
    { label: 'Haarlem', href: 'https://juistemakelaar.nl/makelaars/noord-holland/haarlem/' },
    { label: 'Amersfoort', href: 'https://juistemakelaar.nl/makelaars/utrecht/amersfoort/' },
    { label: 'Almere', href: 'https://juistemakelaar.nl/makelaars/flevoland/almere/' },
    { label: 'Enschede', href: 'https://juistemakelaar.nl/makelaars/overijssel/enschede/' },
    { label: 'Arnhem', href: 'https://juistemakelaar.nl/makelaars/gelderland/arnhem/' },
    { label: 'Dordrecht', href: 'https://juistemakelaar.nl/makelaars/zuid-holland/dordrecht/' },
    { label: 'Den-Bosch', href: 'https://juistemakelaar.nl/makelaars/noord-brabant/den-bosch/' },
    { label: 'Maastricht', href: 'https://juistemakelaar.nl/makelaars/limburg/maastricht/' },
    { label: 'Apeldoorn', href: 'https://juistemakelaar.nl/makelaars/gelderland/apeldoorn/' },
    { label: 'Leiden', href: 'https://juistemakelaar.nl/makelaars/zuid-holland/leiden/' },
    { label: 'Alkmaar', href: 'https://juistemakelaar.nl/makelaars/noord-holland/alkmaar/' },
    { label: 'Zaandam', href: 'https://juistemakelaar.nl/makelaars/noord-holland/zaandam/' },
    { label: 'Zeist', href: 'https://juistemakelaar.nl/makelaars/utrecht/zeist/' },
    { label: 'Andere plaatsen', href: 'https://juistemakelaar.nl/makelaars/' },
  ],
}

const links = [
  {
    label: 'Huis verkopen',
    children: [
      { label: 'Beste 9 tips huis snel verkopen', href: 'https://juistemakelaar.nl/tip/9-beste-tips-huis-verkopen/' },
      { label: 'Overzicht makelaars Nederland', href: 'https://juistemakelaar.nl/makelaar/' },
      { label: 'Wat kost een verkoopmakelaar?', href: 'https://juistemakelaar.nl/tip/kosten-verkoopmakelaar/' },
      { label: 'Hoe vergelijk je makelaars?', href: 'https://juistemakelaar.nl/tip/makelaars-vergelijken/' },
      {
        label: 'Stappenplan succesvol je huis verkopen',
        href: 'https://juistemakelaar.nl/tip/stappenplan-huis-verkopen/',
      },
      { label: 'Taken verkoopmakelaar', href: 'https://juistemakelaar.nl/tip/taken-verkoopmakelaar/' },
      { label: 'Dubbele woonlasten, wat nu?', href: 'https://juistemakelaar.nl/tip/twee-huizen-dubbele-woonlasten/' },
      { label: 'Huis verkopen belasting', href: 'https://juistemakelaar.nl/tip/huis-verkopen-belasting/' },
      { label: 'Hoe je huis snel verkopen', href: 'https://juistemakelaar.nl/huis-verkopen/' },
      { label: 'Tips om de beste makelaar te vinden', href: 'https://juistemakelaar.nl/tip/' },
    ],
  },
  {
    label: 'Huis kopen',
    children: [
      {
        label: 'Hoe ga jij een aankoopmakelaar vergelijken?',
        href: 'https://juistemakelaar.nl/tip/aankoopmakelaar-vergelijken/',
      },
      {
        label: 'De 20 ultieme tips bij een huis kopen',
        href: 'https://juistemakelaar.nl/tip/20-ultieme-tips-huis-kopen/',
      },
      { label: 'Kosten aankoopmakelaar', href: 'https://juistemakelaar.nl/tip/kosten-aankoopmakelaar/' },
      { label: 'Taken aankoopmakelaar', href: 'https://juistemakelaar.nl/tip/taken-aankoopmakelaar/' },
      { label: 'Hét stappenplan om een huis te kopen', href: 'https://juistemakelaar.nl/tip/stappenplan-huis-kopen/' },
      { label: 'Kosten Koper (k.k.)', href: 'https://juistemakelaar.nl/tip/kosten-koper/' },
      { label: 'Alles over NHG', href: 'https://juistemakelaar.nl/tip/nationale-hypotheek-garantie/' },
      { label: 'De betekenis van onder bod', href: 'https://juistemakelaar.nl/tip/onder-bod/' },
      { label: 'Een geschikte taxateur vinden', href: 'https://juistemakelaar.nl/taxateur/' },
      { label: 'Soorten woningen', href: 'https://juistemakelaar.nl/type-woning/' },
    ],
  },
  {
    label: 'Over ons',
    children: [
      { label: 'Home', href: '/' },
      { label: 'Voor makelaars', href: '/aanmelden-voor-makelaars/' },
      { label: 'Nieuws', href: '/nieuws/' },
      { label: 'Over ons', href: '/over-ons/' },
      { label: 'Contact', href: '/contact/' },
      { label: 'Werken bij Juiste Makelaar', href: '/werken-bij/' },
      // { label: 'Privacybeleid', href: '/privacybeleid/' },
      // { label: 'Cookie Policy', href: '/cookies/' },
      // { label: 'Algemene Voorwaarden', href: '/algemene-voorwaarden/' },
    ],
  },
  {
    label: 'Info',
    children: [
      { label: 'H.J.E. Wenckebachweg 144', href: null },
      { label: '1114AD Amsterdam', href: null },
      { label: '020 244 2818', href: 'tel:0202442818' },
      { label: 'info@juistemakelaar.nl', href: 'mailto:info@juistemakelaar.nl' },
      { label: 'KvK: 81234567', href: null },
    ],
  },
]
</script>

<template>
  <UFooter class="bg-gray-50 pt-12 pb-6">
    <template #bottom>
      <UContainer>
        <div class="w-full mt-12">
          <div class="space-y-16 md:grid md:grid-cols-4 md:gap-8 md:space-y-0">
            <div
              v-for="column in links"
              :key="column.label"
            >
              <h3 class="text-base font-medium text-gray-900 border-b border-gray-200 pb-2">
                {{ column.label }}
              </h3>
              <ul
                role="list"
                class="mt-6 space-y-4"
              >
                <li
                  v-for="link in column.children"
                  :key="link.label"
                  class="text-sm"
                >
                  <NuxtLink
                    v-if="link.href"
                    :to="link.href"
                    class="text-gray-500 hover:text-gray-700"
                  >{{ link.label }}</NuxtLink>
                  <span v-else>{{ link.label }}</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="py-12 sm:py-12">
            <div class="mx-auto max-w-2xl px-6 lg:px-8">
              <h2 class="text-center text-lg/8 font-semibold text-gray-900">
                {{ content.logo.title }}
              </h2>
              <div class="flex flex-wrap md:flex-nowrap gap-4">
                <NuxtImg
                  class="max-h-8 md:max-h-12 w-full object-contain"
                  src="/img/footer/logos/branche_1.webp"
                  alt="Branche"
                />
                <NuxtImg
                  class="max-h-8 md:max-h-12 w-full object-contain"
                  src="/img/footer/logos/Juistemakelaars-vastgoedpro.webp"
                  alt="Vastgoedpro"
                />
                <NuxtImg
                  class="max-h-8 md:max-h-12 w-full object-contain"
                  src="/img/footer/logos/vbologo.webp"
                  alt="VBO"
                />
              </div>
            </div>
          </div>

          <div class="my-12">
            <h3 class="text-base font-medium text-gray-900 border-b border-gray-200 pb-2">
              {{ cities.label }}
            </h3>
            <ul
              role="list"
              class="mt-6 flex gap-2 flex-wrap"
            >
              <li
                v-for="city in cities.children"
                :key="city.label"
                class="text-sm"
              >
                <NuxtLink
                  :to="city.href"
                  class="text-gray-500 hover:text-gray-600"
                >{{ city.label }}</NuxtLink>
              </li>
            </ul>
          </div>
        </div>

        <div class="flex justify-between mb-4">
          <p class="text-gray-500 dark:text-gray-400 text-sm">
            Copyright © 2025. All rights reserved.
          </p>
        </div>
      </UContainer>
    </template>

    <template #left>
      <div class="flex flex-col">
        <NuxtImg
          src="/img/logo.webp"
          width="228"
          height="35"
          alt="Juiste makelaar"
        />

        <div>
          <NuxtLink
            :to="content.trustpilot.href"
            target="_blank"
            rel="noopener"
            class="flex gap-1 items-center text-sm mt-4 hover:text-gray-700 text-gray-500"
          >
            <UIcon
              v-for="i in 5"
              :key="i"
              name="i-heroicons-solid-star"
              class="text-yellow-500"
            /> op
            <UIcon
              name="i-simple-icons-trustpilot"
              class="w-4 h-4 px-2"
            />
            Trustpilot
          </NuxtLink>
        </div>
      </div>
    </template>

    <template #right>
      <UButton
        v-for="link in content.socials.links"
        :key="link.label"
        :icon="link.icon"
        color="neutral"
        variant="ghost"
        :to="link.href"
        target="_blank"
      />
    </template>
  </UFooter>
</template>
